import Header from '../components/Header'
import { atom, useAtom } from 'jotai'
import { useState, useEffect, useRef } from 'react'
import axios from "axios";

//import {priceAtom, messageAtom, productAtom, textAtom} from '../atoms/atom.config.js'
import {isSmallAtom,titleAtom,audioFileAtom} from '../atoms/atom.config.js'
import useDeviceSize from '../components/useDeviceSize';
import { mobileWidth, SECTIONS, FEATURES, API,MEDIA } from '../constants';

import {Helmet} from "react-helmet";

import Note from './note'

import sound from '../assets/sounds/RBA_05_Soundscape.mp3'
import spinnerIcon from '../assets/icons/spinner_bird5.svg'
// import spinnerIcon from '../assets/icons/spinner_intro.svg'

export default function Five() {
  const [data, setData] = useState(null);
  const [featuresData, setFeaturesData] = useState(null);
  const [creditsData, setCreditsData] = useState(null);
  const [helpData, setHelpData] = useState(null);
  const [title, setTitle] = useAtom(titleAtom);
  const [audioFile, setAudioFile] = useAtom(audioFileAtom); // "blah.mp3"

  // axios fetch
  const fetchData = async () => {
    try {
      //export const DOMAIN = 'https://beechworth.herokuapp.com/';
      //export const HEADERS = { headers: { 'Access-Control-Allow-Origin': DOMAIN } }
      const response = await axios.get(API.FIVE); //, HEADERS);
      console.log(response.data)
      setData(response.data);

      const response2 = await axios.get(API.FEATURES); //, HEADERS);
      console.log(response2.data)
      setFeaturesData(response2.data);

      const response4 = await axios.get(API.HELP); //, HEADERS);
      console.log(response4.data)
      if(response4.data.length > 0) {
        setHelpData(response4.data[0]);
      }

      //const response3 = await axios.get(API.CREDITS); //, HEADERS);
      //console.log(response3.data)
      //setCreditsData(response3.data);
    } catch(error) {
      console.error(error);
    }
  };

  useEffect(() => {
    //window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    setTitle(SECTIONS.FIVE)
    setAudioFile(sound);
    fetchData()
  }, []);

  

  return (
    <>
      <Helmet>
        <link rel="preload" as="fetch" href={API.FIVE} />
        <link rel="preload" as="fetch" href={API.FEATURES} />
        <link rel="preload" as="fetch" href={API.HELP} />
      </Helmet>
      <Note note={SECTIONS.FIVE} media={MEDIA.FIVE} features={featuresData} data={data} helpData={helpData} credits={creditsData} spinner={spinnerIcon} />
    </>
  )
}

// export default ScrollerSlides 
// export default {
//   ScrollerSlides
// }